export type CaseItem = {
  item: any;
  chance: number;
};

export enum SpinStatus {
  IDLE = 1,
  SPINNING = 2,
  ENDED = 3
}

export type ServiceItem = {
  id: number;
  name: string;
  color: string|null;
  image: ServiceItemImage;
  type: ServiceItemType;
  configuration: ServiceItemConfiguration;
  minValueUsd: number;
  maxValueUsd: number;
};

export type ServiceInventoryItem = {
  id: number;
  status: ServiceInventoryItemStatus;
  serviceItem?: ServiceItem;
};

export type ServiceItemOpenResult = any;

export enum ServiceInventoryItemStatus {
  PENDING = 1,
  USED = 2
}

export const enum ServiceInventoryItemModule {
  MODULE_CREATED_BY_ADMIN = 1,
  MODULE_SEASON_PASS = 2
}

export type ServiceItemImage = {
  fileName: string;
};

export type ServiceItemType = 'customization_case' |
                              'custom_photo' |
                              'event_item' |
                              'item_pack' |
                              'items_case' |
                              'medal' |
                              'nickname_color' |
                              'random_item' |
                              'secret_code' |
                              'sticker' |
                              'sticker_pack' |
                              'wager_money' |
                              'battle_item' |
                              'buff';

export const USABLE_SERVICE_ITEMS: ServiceItemType[] = [
  'customization_case',
  'item_pack',
  'items_case',
  'random_item',
  'secret_code',
  'sticker_pack',
  'wager_money'
];

export const ITEM_TYPE_NAME: Record<string, string> = {
  'customization_case': $localize`:@@service_items.type.customization_case:Кейс кастомизации`,
  'custom_photo': $localize`:@@service_items.type.custom_photo:Аватарка`,
  'event_item': $localize`:@@service_items.type.event_item:Ивентный предмет`,
  'item_pack': $localize`:@@service_items.type.item_pack:Пак предметов`,
  'items_case': $localize`:@@service_items.type.items_case:Кейс с предметами`,
  'medal': $localize`:@@service_items.type.medal:Медаль`,
  'nickname_color': $localize`:@@service_items.type.nickname_color:Цвет никнейма`,
  'random_item': $localize`:@@service_items.type.random_item:Случайный предмет`,
  'secret_code': $localize`:@@service_items.type.secret_code:Секретный код`,
  'sticker': $localize`:@@service_items.type.sticker:Стикер`,
  'sticker_pack': $localize`:@@service_items.type.sticker_pack:Набор стикеров`,
  'wager_money': $localize`:@@service_items.type.wager_money:Бонус на баланс`
};

export type ServiceItemConfiguration = CustomizationCaseConfiguration |
                                       CustomPhotoConfiguration |
                                       EventItemConfiguration |
                                       ItemPackConfiguration |
                                       ItemsCaseConfiguration |
                                       MedalConfiguration |
                                       NicknameColorConfiguration |
                                       RandomItemConfiguration |
                                       SecretCodeConfiguration |
                                       StickerConfiguration |
                                       StickerPackConfiguration |
                                       WagerMoneyConfiguration |
                                       BattleItemConfiguration;

interface AbstractCaseConfiguration {
  items: Array<{
    item: any;
    chance: number;
  }>;
  spinnerCellWidth: number;
}

export type BattleItemConfiguration = {
  skeletonImage: string|null;
};

export type CustomizationCaseConfiguration = AbstractCaseConfiguration

export type CustomPhotoConfiguration = {
  url: string;
};

export type EventItemConfiguration = Record<string, never>;

export type ItemPackConfiguration = {
  items: any[];
};

export type ItemsCaseConfiguration = AbstractCaseConfiguration

export type MedalConfiguration = Record<string, never>;

export type NicknameColorConfiguration = {
  color: string;
};

export type RandomItemConfiguration = {
  items: any[];
};

export type SecretCodeConfiguration = {
  bonusAmountUsd: number;
  bonusAmountPct: number;
  minDepositAmountUsd: number;
  expirationSeconds: number;
};

export type StickerConfiguration = {
  stickerId: number;
};

export type StickerPackConfiguration = {
  stickers: any[];
};

export type WagerMoneyConfiguration = {
  bonusAmountUsd: number;
  wagerMultiplier: number;
  expirationHours: number;
};

export type DialogData = {
  openResult?: ServiceItemOpenResult;
  serviceItem: ServiceItem;
  inventoryItem: ServiceInventoryItem|undefined;
  callback: (result: ServiceItemOpenResult) => void;
  dialogTitle?: string;
  isHiddenButton?: boolean;
};
